import { ReactJsonEditor } from "@/src/components";
import { Edit, TextInput, useRecordContext, useEditContext, Form, SimpleForm, useInput } from "react-admin";
import { Content } from "vanilla-jsoneditor";
import { useState, useEffect } from "react";
import { Button, Box, Stack } from "@mui/material";

export function SettingsEdit() {
    return (
        <Edit>
            <SettingsEditForm />
        </Edit>
    )
}

const SettingsEditForm = () => {
    const { record, save, saving, refetch,isFetching } = useEditContext();
    const [currentData, setCurrentData] = useState(record);
    const [isChanged, setIsChanged] = useState(false);

    const handleJsonChange = (content: any, previousContent: Content, onChangeStatus: any) => {
        console.log(content);
        if (content.json) {
            setCurrentData(content.json);
            setIsChanged(true);
        }
    }

    const handleSave = () => {
        if (save && currentData) {
            save(currentData);
            setIsChanged(false); // Reset changed flag after save
        }
    }

    const handleReload = async () => {
        try {
            const result = await refetch();
            if (result.data) {
                console.log('Refetch completed, updating data:', result.data);
                setCurrentData(result.data);
                setIsChanged(false);
            }
        } catch (error) {
            console.error('Refetch failed:', error);
        }
    }

    return (
        <Form>
            <Stack direction="column" spacing={2} padding={2}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {/* <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={saving || !isChanged}
                    >
                        {saving ? 'Saving...' : 'Save'}
                    </Button> */}
                    <Button
                        variant="outlined"
                        onClick={handleReload}
                        disabled={saving || isFetching}
                    >
                        {isFetching ? 'Reloading...' : 'Reload'}
                    </Button>
                </Box>
                <TextInput source="id" label={"Settings Id"} disabled />
                <ReactJsonEditor
                    content={{ json: currentData }}
                    onChange={handleJsonChange}
                />
            </Stack>
        </Form>
    )
}